var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCurvedCaret = function SvgCurvedCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "curved-caret_svg__a",
    width: 48,
    height: 48,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#curved-caret_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#curved-caret_svg__b)",
    d: "M48 13a1.98 1.98 0 0 0-.594-1.406 1.98 1.98 0 0 0-2.812 0l-17.656 17.75c-1.557 1.567-4.09 1.557-5.657 0L3.406 11.594a1.98 1.98 0 0 0-2.812 0 1.98 1.98 0 0 0 0 2.812l17.875 17.782c3.134 3.113 8.198 3.102 11.312-.032l17.625-17.75c.39-.392.596-.894.594-1.406"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "curved-caret_svg__b",
    x1: -43.185,
    x2: -43.185,
    y1: 11.008,
    y2: 34.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A31D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003FFF"
  })))));
};
export default SvgCurvedCaret;